import theme from '@styles/theme';
export default {
  availableFilters: {
    position: 'sticky',
    top: 0,
    left: 0,
    width: ['calc(100% + 32px)', 'calc(100% + 32px)', 'calc(100% + 48px)', 'calc(100% + 48px)', '100%'],
    display: 'flex',
    gap: ['16px', '16px', '16px', '16px', '24px'],
    m: ['40px -16px 0 -16px', '40px -16px 0 -16px', '40px -24px 0 -24px', '36px -24px 0 -24px', '88px 0 0 0'],
    p: ['12px 16px', '12px 16px', '12px 24px', '14px 24px', '14px 0'],
    zIndex: theme.zIndex.filters,
    background: theme.rawColors.neutralWhite,
    overflowX: 'auto',
    // NOTE: tmp hide scrollbar (waiting for keen slider implementation)
    '::-webkit-scrollbar': {
      display: 'none'
    },
    scrollbarWidth: 'none',
    msOverflowStyle: 'none'
  },
  buttonStandard: {
    width: [40, 40, 40, 40, 'auto'],
    p: ['0 12px', '0 12px', '0 12px', '0 12px', '0 24px'],
    height: 40,
    '&:hover': {
      backgroundColor: theme.rawColors.neutralBlack,
      borderColor: theme.rawColors.darkGrey700,
      color: theme.rawColors.neutralWhite,
      path: {
        fill: `${theme.rawColors.neutralWhite} !important`
      }
    },
    '.buttonText': {
      display: ['none', 'none', 'none', 'none', 'block']
    },
    '.icon': {
      margin: ['0', '0', '0', '0', '0 0 0 16px']
    }
  },
  buttonActiveFilter: {
    color: theme.rawColors.darkGrey700,
    background: theme.rawColors.lightGrey500,
    height: 40,
    path: {
      fill: `${theme.rawColors.darkGrey700} !important`
    },
    '&:hover': {
      color: theme.rawColors.darkGrey700,
      path: {
        fill: `${theme.rawColors.darkGrey700} !important`
      }
    },
    '.button-children-wrapper': {
      alignItems: 'center'
    }
  },
  buttonFilter: {
    height: 40,
    '.button-children-wrapper': {
      alignItems: 'center'
    }
  }
};